import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-pin',
  templateUrl: './icon-pin.component.html',
  styles: []
})
export class IconPinComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
